import SendEmailModal from './SendEmailModal';
import SendEmailErrorModal from './SendEmailErrorModal';

export const SEND_EMAIL_MODAL_KEY = 'alternateEmailModal';
export const SEND_EMAIL_ERROR_MODAL_KEY = 'alternateEmailErrorModal';

export const modalConfig = {
    [SEND_EMAIL_MODAL_KEY]: {
        id: 'alternateEmail',
        modalComponent: SendEmailModal,
    },
    [SEND_EMAIL_ERROR_MODAL_KEY]: {
        id: 'alternateEmailError',
        modalComponent: SendEmailErrorModal,
    },
};
